import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzVc6 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_VC6: Record<
  PageIdWoofzVc6,
  TPageConfig
> = {
  [PageId.SEX_VC6]: {
    id: PageId.SEX_VC6,
  },
  [PageId.DOG_AGE_VC6]: {
    id: PageId.DOG_AGE_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.SHELTER_VC6]: {
    id: PageId.SHELTER_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_VC6]: {
    id: PageId.DOG_BREED_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_VC6]: {
    id: PageId.BEHAVIOR_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.HEALTH_ISSUES_VC6]: {
    id: PageId.HEALTH_ISSUES_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.GOALS_QUESTION_VC6]: {
    id: PageId.GOALS_QUESTION_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.URGE_VC6]: {
    id: PageId.URGE_VC6,
  },
  [PageId.FEED_VC6]: {
    id: PageId.FEED_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.WALK_VC6]: {
    id: PageId.WALK_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.STRESS_VC6]: {
    id: PageId.STRESS_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.HOME_ALONG_VC6]: {
    id: PageId.HOME_ALONG_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.ACTIVITY_VC6]: {
    id: PageId.ACTIVITY_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.DESCRIBE_VC6]: {
    id: PageId.DESCRIBE_VC6,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.ALMOST_DONE_VC6]: {
    id: PageId.ALMOST_DONE_VC6,
  },
  [PageId.TRAINER_IS_READY_VC6]: {
    id: PageId.TRAINER_IS_READY_VC6,
  },
  [PageId.DOG_SUMMARY_VC6]: {
    id: PageId.DOG_SUMMARY_VC6,
  },
  [PageId.FEATURE_DESCRIPTION_VC6]: {
    id: PageId.FEATURE_DESCRIPTION_VC6,
  },
  [PageId.CYNOLOGISTS_VC6]: {
    id: PageId.CYNOLOGISTS_VC6,
  },
  [PageId.OUR_MISSION_VC6]: {
    id: PageId.OUR_MISSION_VC6,
    hasHeader: true,
  },
  [PageId.LIMITED_OFFER_VC6]: {
    id: PageId.LIMITED_OFFER_VC6,
  },
  [PageId.SUBSCRIPTIONS_TRIAL_PRICE_VC6]: {
    id: PageId.SUBSCRIPTIONS_TRIAL_PRICE_VC6,
  },
  [PageId.SUBSCRIPTIONS_TRIAL_PRICE_2_VC6]: {
    id: PageId.SUBSCRIPTIONS_TRIAL_PRICE_2_VC6,
  },
  [PageIdWoofzVc6.CALENDLY_VC6]: {
    id: PageIdWoofzVc6.CALENDLY_VC6,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzVc6.ALL_SET_VC6]: {
    id: PageIdWoofzVc6.ALL_SET_VC6,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.ACCOUNT_NOVE8]: {
    id: PageId.ACCOUNT_NOVE8,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
